export const whatsappNumber = "5519974044363";

export const whatsappMessage =
  "Olá! Quero saber mais sobre os produtos para colocar no cardápio do meu restaurante.";

export const companyInfo = {
  email: "armandomaeno@gmail.com",
  phone: "19 97404-4363",
  address: "Av. Suamirim, 294 - Barra do Ribeira, Iguape - SP",
};

export const benefits = [
  {
    title: "Aumente o ticket médio",
    text: "Inclua sobremesas prontas e desejadas no cardápio sem complicar sua operação.",
  },
  {
    title: "Produto fácil de vender",
    text: "Sabores conhecidos, apresentação atrativa e alta aceitação em restaurantes japoneses.",
  },
  {
    title: "Operação simples",
    text: "Produtos pensados para facilitar o preparo, armazenamento e venda no dia a dia.",
  },
  {
    title: "Boa margem para o restaurante",
    text: "Venda como sobremesa premium e crie novas oportunidades de faturamento.",
  },
];